module.exports = __webpack_public_path__ + "img/254.85385faa.jpg";